"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var common_utils_1 = require("../../tools/common-utils");
var buttons_1 = require("../buttons");
var YearPickerContent = function (_a) {
    var value = _a.value, show = _a.show, onChange = _a.onChange, forwardedRef = _a.forwardedRef;
    var _b = (0, react_1.useState)(value), year = _b[0], setYear = _b[1];
    var yearsRefs = (0, react_1.useRef)([]);
    var containerRef = (0, react_1.useRef)(null);
    var years = (0, react_1.useMemo)(function () { return (0, common_utils_1.range)(1900, (year || value || 2023) + 70); }, [year, value]);
    var isClicked = (0, react_1.useCallback)(function (target) { var _a; return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(target); }, []);
    (0, react_1.useImperativeHandle)(forwardedRef, function () { return ({ isClicked: isClicked }); });
    var scrollToSelected = (0, react_1.useCallback)(function (to) {
        var _a;
        var index = years.findIndex(function (y) { return y === (to || year); });
        (_a = yearsRefs.current) === null || _a === void 0 ? void 0 : _a[index].scrollIntoView({ behavior: 'smooth' });
    }, []);
    (0, react_1.useEffect)(function () {
        if (show) {
            scrollToSelected(year);
        }
    }, [year, show, scrollToSelected]);
    var handleSelect = function (y) { return function () {
        setYear(y);
        onChange === null || onChange === void 0 ? void 0 : onChange(y);
        scrollToSelected(y);
    }; };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ ref: containerRef, className: (0, classnames_1.default)('squid-mt-2 squid-grid squid-items-center squid-grid-cols-4 squid-w-full squid-max-h-60 squid-gap-2 squid-overflow-y-auto', { 'squid-hidden': !show }) }, { children: years.map(function (y, index) {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ ref: function (ref) {
                    yearsRefs.current[index] = ref;
                } }, { children: (0, jsx_runtime_1.jsx)(buttons_1.SimpleButton, { title: y.toString(), active: y === year, onClick: handleSelect(y), "aria-label": y.toString() }) }), y.toString()));
        }) })));
};
exports.default = YearPickerContent;
